// extracted by mini-css-extract-plugin
module.exports = {"theme":"\"../../themes/theme.module.css\"","actionTextSmall":"theme_actionTextSmall__1U-V4","icon":"StyledCheckbox_icon__cGiCy"};